import React, { ReactElement, useState } from "react";

import Link from "components/Link";
import { BodyM } from "style/components/Typography";

import {
    CloseButton,
    Container,
    Content,
    LinkWrapper,
    StyledSection,
} from "./SystemMessage.styled";
import SystemMessageProps from "./SystemMessageProps";
const SystemMessage = ({
    message,
    link,
    l18n,
    lastUpdated,
}: SystemMessageProps): ReactElement => {
    const [hidden, setHidden] = useState<boolean>(
        (sessionStorage.getItem("system_message") === "hide" && !lastUpdated) ||
            sessionStorage.getItem("system_message") === lastUpdated,
    );
    const closeAlert = () => {
        setHidden(true);
        sessionStorage.setItem("system_message", lastUpdated || "hide");
    };
    return (
        <>
            {!hidden && (
                <StyledSection colorTheme="coral" alignItems="center">
                    <CloseButton
                        onClick={() => closeAlert()}
                        a11y={true}
                        iconOnly={true}
                        icon={"close28"}
                        actionTheme="blue"
                    >
                        {l18n?.closeLabel || "Close"}
                    </CloseButton>
                    <Container>
                        {message && (
                            <Content
                                content={message}
                                renderElement={<BodyM />}
                            />
                        )}
                        {link?.url && (
                            <LinkWrapper>
                                <Link
                                    title={link?.title}
                                    to={link?.url}
                                    hoverSpan={true}
                                    target={link.target}
                                >
                                    <span>{link?.linkText}</span>
                                </Link>
                            </LinkWrapper>
                        )}
                    </Container>
                </StyledSection>
            )}
        </>
    );
};

export default React.memo(SystemMessage);
